module.exports = __webpack_public_path__ + "img/thumbnail_BlueWildebeest_m_albino.5d3053f5.png";